//filters
export const FILTERS = 'filters';
export const TABLE_SETTINGS = 'tableSettings';
// filters dependencies
export const FILTERS_DEPENDENCIES = {};

// columns
export const COLUMN_FINAL = 'final';
export const COLUMN_CURRENT = 'current';
export const COLUMN_STATUS = 'status';
export const COLUMN_COMMENT = 'comment';
export const COLUMN_DATE_UPDATED = 'dateUpdated';
export const COLUMN_AUTHOR = 'author';
export const COLUMN_DATE_CREATED = 'dateCreated';

export const EMPTY_PLAN = 0;
export const DUPLICATE_PLAN = 1;
export const DUPLICATE_PLAN_WITH_KPI = 2;

export const EVENT_RELOAD_GRID = 'marketing-planning-reload-grid';
